<template>
  <div class="pay">
    <div class="share_head">
      <div class="left">
        <img src="../pay/pay_img/logo.png" alt="" />
        <div class="left-text">
          <p>{{ $t('HappyVoice') }}</p>
          <p>{{ $t('OnlineStorage') }} — {{ $t('CER') }}</p>
        </div>
      </div>

      <div class="right">
        <input type="text" style="display: none" />
        <div class="right-content" @click="downLaod">{{ $t('Download') }}</div>
      </div>
    </div>

    <body class="body">
      <div class="body-box">
        <div
          v-if="status"
          class="warning"
          style="
      width:97%;
      margin-top:.625rem;
      color:#721c24;
      border-radius:.375rem;
      padding:.3125rem;
      font-size:.875rem;
      line-height:1.3125rem;
      background-color:#f8d7da;
    }"
        >
          {{ text }}
          <!-- 為了提升歌友儲值的服務品質，MyCard儲值管道{{ preserveTime.start }}至{{
            preserveTime.end
          }}進行系統升級維護！ -->
        </div>
        <p class="title" style="margin-top: 0.75rem; margin-left: 0.0625rem">
          {{ $t('Stored') }} ID
        </p>
        <div class="input">
          <input
            type="text"
            :placeholder="$t('Stored') + ' ID'"
            v-model="InputId"
            @input="input"
          />
        </div>
        <p class="title">{{ $t('Confirm') }} ID</p>

        <div class="user_info">
          <div>
            <img
              class="user-avater"
              v-if="init_img"
              :src="init_img"
              width="64"
              height="64"
              alt
            />
            <img
              class="user-avater"
              width="64"
              height="64"
              v-else
              :src="'http://api.vivasing.com/userimg.php?uid=' + userUrlId"
              alt=""
            />
          </div>

          <div class="user-name">
            {{ userName }}
            <br />
            <small>〈{{ userID }}〉</small>
          </div>
        </div>

        <p class="title">{{ $t('StoredMode') }}</p>

        <div class="pay_types">
          <!-- <a
            class="mycard"
            :class="{ active: isactive == 6 }"
            @click="choose(6)"
            style="margin-top: 1.25rem; justify-content: center"
          > -->
            <!-- <div class="bage">{{ $t('TaiWan') }}</div> -->
            <!-- <img
              src="./pay_img/nganluong.png"
              height="37"
              alt=""
              style="width: 13rem !important"
            /> -->
            <!-- <p>{{ $t('upay') }}</p>
          </a> -->
          <!-- <a
            class="mycard"
            :class="{ active: isactive == 0 }"
            @click="choose(0)"
          >
            <img src="./pay_img/mycard.png" width="160" height="37" alt />
            <p style="font-size: 0.875rem">
              {{ status ? this.$t('UnderMaintenance') : this.$t('PATM') }}
            </p>
            <p style="padding: 0.625rem"></p>
          </a> -->
          <!-- <a
                        class="mycard"
                        :class="{ active: isactive == 1 }"
                        @click="choose(1)"
                        style="margin-top:1.25rem"
                    >
                        <img src="./pay_img/iPasspay.jpg" width="160" height="37" alt="" />
                        <p>信用卡支付</p>
                    </a> -->
          <a
            class="mycard"
            :class="{ active: isactive == 6 }"
            @click="choose(6)"
            style="margin-top: 1.20rem;"
          >
            <!-- <div class="bage">{{ $t('TaiWan') }}</div> -->
            <img
              src="./pay_img/upay.png"
              height="37"
			  style="width: 8rem !important;margin-top: 1.20rem"
              alt=""
            />
            <p>{{$t('upay')}}</p>
          </a>
		  <a
            class="mycard"
            :class="{ active: isactive == 1 }"
            @click="choose(1)"
            style="margin-top: 1.25rem"
          >
            <!-- <div class="bage">{{ $t('TaiWan') }}</div> -->
            <img src="./pay_img/Payermax.jpg" width="160" height="37" alt="" 
			style="margin-top: 1.20rem"/>
            <p>{{ $t('ALMAS') }}</p>
          </a>
          <!-- <a
            class="mycard"
            :class="{ active: isactive == 2 }"
            @click="choose(2)"
            style="margin-top: 1.25rem"
          >
            <div class="bage">{{ $t('Malaysia') }}</div>
            <img src="./pay_img/Payermax.jpg" width="160" height="37" alt="" />
            <p>{{ $t('ALMAS') }}</p>
          </a> -->
          <a
            class="mycard"
            :class="{ active: isactive == 5 }"
            @click="choose(5)"
            style="margin-top: 1.20rem"
          >
            <!-- <div class="bage">{{ $t('TaiWan') }}</div> -->
            <img
              src="./pay_img/nganluong.png"
              height="37"
              alt=""
              style="width: 13rem !important;margin-top: 1.20rem"
            />
            <p>Ví Tiền</p>
          </a>
         
        </div>

        <a class="next" @click="getOrderList" ref="next">{{ $t('Next') }}</a>
      </div>
    </body>

    <footer class="footer">
      <div class="page-footer">{{ $t('Service') }}(ID:10400)</div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'pay',
  data () {
    return {
      userInfo: [],
      userName: this.$t('UserName'),
      userID: this.$t('UserID'),
      isactive: 6, //0默认点数卡为选中
      InputId: '',
      hasUser: 0,
      hasUserStatus: false,
      init_img: require('./pay_img/m_head.png'),
      dataList: [],
      timer: null,
      text: '',
      userUrlId: '',
      status: false, //是否在维护
      preserveTime: '', //維護時間段
    }
  },
  methods: {
    choose (isactive) {
      if (this.status && isactive == 0) {
        alert(this.$t('McMaintenance'))
        return
      }
      this.isactive = isactive
    },
    //获取是否在维护状态
    getStatus () {
      var time = [{ start: '2021-8-12 10:52', end: '2021-8-12 15:40' }]
      var now = Math.round(new Date() / 1000),
        start,
        end
      return time.find(item => {
        start = Math.round(new Date(item.start) / 1000)
        end = Math.round(new Date(item.end) / 1000)
        return now >= start && now <= end
      })
    },
    input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.getUserInfo()
        }, 300)
      } else {
        this.timer = setTimeout(() => {
          this.getUserInfo()
        }, 300)
      }
    },
    getOrderList () {
      // this.$router.push('order')
      var api, type
      if (this.isactive == 0) {
        type = 1 //表示第一种充值方式
        api = '../api/api2.php?c=commodity._mycardCommodityList&type=1'
      }
      // else if (this.isactive == 1) {
      //     type = 2 //表示第二种充值方式
      //     api = '../api/api2.php?c=commodity._iPasspayCommodityList&type=1'
      // }
      else if (this.isactive == 1) {
        type = 3 //表示第三种充值方式
        api = '../api/api2.php?c=commodity._payermaxCommodityList&type=1&unit=VND'
      } else if (this.isactive == 5) {
        type = 5 //表示第五种充值方式
        api = '../api/api2.php?c=commodity._nganluongCommodityList&type=1'
      } else if (this.isactive == 6) {
        type = 6 //表示第六种充值方式
        api = '../api/api2.php?c=commodity._upayCashCardCommodityList&type=1'
      } else {
        type = 4 //表示第四种充值方式
        api = '../api/api2.php?c=commodity._payermaxCommodityList&type=1&unit=MYR'
      }
      if (this.hasUserStatus) {
        this.$axios.get(api).then(res => {
          this.dataList = res.data.data
          this.$router.push({
            path: 'order',
            query: { datalist: this.dataList, userInfo: this.userInfo, type },
          })
        })
      } else {
        alert(this.$t('PCAU'))
      }
    },
    getUserInfo () {
      if (this.InputId.length >= 6) {
        this.$axios
          .get(`../api/api.php?c=user._getUserCard&get_user_id=${this.InputId}`)
          .then(res => {
            this.userInfo = res.data
            if (res.data.code != this.hasUser) {
              this.$refs.next.style.background = '#6c757d'
              this.init_img = require('./pay_img/m_head.png')
              this.userName = this.$t('UserError')
              this.userID = this.$('IDError')
            } else {
              this.$refs.next.style.background = '#1278f3'
              this.init_img = false
              this.userUrlId = this.InputId
              this.userName = res.data.data.nickname
              this.userID = res.data.data.uid
              this.hasUserStatus = true
            }
          })
      }
    },
    //节流函数
    // debounce (fn,delay = 300) {
    //     var timer = null
    //     return function() {
    //         if (timer != null) {
    //             clearTimeout(timer)
    //         }else{
    //             timer = setTimeout(fn,delay)
    //         }
    //     }
    // },
    downLaod () {
      if (this._isMobile()) {
        this.isIosorAndroid()
      } else {
        gtag('event', 'view_promotion', {
          promotion_name: 'pay_pc',
        })
        _hmt.push(['_trackEvent', 'share_music', 'pc', 'pc'])
        window.location.href = '../api/jump.php?targer=pc'
      }
    },
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    isIosorAndroid () {
      const u = navigator.userAgent,
        app = navigator.appVersion
      //const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      if (isiOS) {
        gtag('event', 'view_promotion', {
          promotion_name: 'pay_ios',
        })
        _hmt.push(['_trackEvent', 'share_music', 'ios', 'ios_app'])
        window.location.href = '../api/jump.php?targer=ios'
      } else {
        gtag('event', 'view_promotion', {
          promotion_name: 'pay_android',
        })
        _hmt.push(['_trackEvent', 'share_music', 'android', 'android_app'])
        window.location.href = '../api/jump.php?targer=android'
      }
    },
    //替換多語言轉換的 * 和 $
    maintainText () {
      this.text = this.$t('MaintainText').replace('*', this.preserveTime.start)
      this.text = this.text.replace('$', this.preserveTime.end)
    },
  },
  mounted () {
    this.preserveTime = this.getStatus() || ''
    if (this.preserveTime) {
      this.status = true
      this.isactive = 1
    }
    this.maintainText()
  },
}
</script>

<style lang="stylus" scoped>
.pay {
  .share_head {
    display: flex;
    width: 100%;
    background-color: #313131;

    .left {
      flex: 2;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-left: 0.625rem;
      color: #ffffff;

      img {
        width: 2.375rem;
        height: 2.375rem;
      }

      .left-text {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin-left: 0.625rem;
        font-size: 0.75rem;
        line-height: 0.875rem;

        :first-child {
          margin-top: 0.625rem;
          margin-bottom: 0.375rem;
          font-size: 1rem;
        }

        :last-child {
          color: #cdcdcd;
        }
      }
    }

    .right {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;

      .right-content {
        border-radius: 0.125rem;
        width: 4.1875rem;
        height: 1.5rem;
        font-size: 0.75rem;
        background: #1278F3;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
      }
    }
  }

  .body {
    width: 100%;

    .body-box {
      width: 93%;
      margin: 0 auto;

      .title {
        padding-top: 0.75rem;
        font-size: 90%;
        font-weight: bold;
        font-family: Microsoft JhengHei;
      }

      .input {
        width: 97%;
        margin-top: 0.6875rem;
        height: 2.375rem;

        input {
          width: 100%;
          height: 2.375rem;
          border: 0.0625rem solid #C9C8CB;
          padding-left: 0.625rem;
          border-radius: 0.375rem;
        }
      }

      .user_info {
        margin-top: 0.8125rem;
        height: 4.5rem;
        display: flex;
        justify-content: center;
        align-items: center;

        .user-avater {
          border-radius: 50%;
          border: 0.0625rem solid #ccc;
        }

        .user-name {
          text-align: center;
          height: 4.5rem;
          line-height: 2.0625rem;

          small {
            line-height: 0.3125rem;
            font-size: 0.75rem;
          }
        }
      }

      .pay_types {
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5625rem;
        width: 100%;

        .mycard {
          position: relative;
          flex: 0 0 100%;
          height: 4.58rem;
          border: 0.0625rem solid #A5B1B8;
          border-radius: 0.25rem;
          text-align: center;
          overflow: hidden;
          margin-top: 1.125rem !important;
          display: flex;
          flex-direction: column;
          // justify-content: center;
          align-items: center;

          img {
            margin-top: 0.3125rem;
          }
        }

        .active {
          background: #fff;
          border: 0.0625rem solid #F55D3E;
          color: #F55D3E;

          .bage {
            background: #f46c54;
          }
        }
      }

      .next {
        display: inline-block;
        margin-top: 1.25rem;
        width: 100%;
        height: 2.375rem;
        line-height: 2.375rem;
        text-align: center;
        background-color: #6c757d;
        border-color: #6c757d;
        opacity: 0.65;
        font-size: 1rem;
        color: #fff;
        border-radius: 0.25rem;
      }
    }
  }

  .footer {
    width: 85%;
    margin: 1.25rem auto;

    .page-footer {
      color: #a5a5a5;
      font-size: 80%;
      text-align: center;
      line-height: 1rem;

      a {
        display: inline-block;
        color: #007bff;
      }
    }
  }

  .bage {
    width: 5.375rem;
    font-size: 0.9375rem;
    color: #fff;
    background: #a5b1b8;
    position: absolute;
    top: 0;
    right: 0;
    height: 2.25rem;
    text-align: center;
    line-height: 2.25rem;
    border-radius: 0 0 0 0.25rem;
  }
}
</style>
